export default "__VITE_ASSET__69aa2698__"